import * as amplitude from '@amplitude/analytics-browser';

import { SnowplowService } from 'wanderu-service-analytics';

function sortCarriers(type, carriers, carrierCode, action) {
    let selectedCarriers;
    let unselectedCarriers;

    selectedCarriers = Object.keys(carriers)
        .filter((carrier) => carriers?.[carrier]?.[type]?.isActive);

    const selectedCarriersBefore = [...selectedCarriers];

    if (action === 'click_only') {
        return {
            selectedCarriers: [carrierCode],
            selectedCarriersBefore,
            unselectedCarriers: Object.keys(carriers).filter((carrier) => carrier !== carrierCode),
        };
    }

    if (action === 'select') {
        selectedCarriers.push(carrierCode);
    } else {
        selectedCarriers.splice(selectedCarriers.indexOf(carrierCode), 1);
    }

    unselectedCarriers = Object.keys(carriers).filter((carrier) => {
        if (carriers[carrier][type]) {
            return !selectedCarriers.includes(carrier);
        }
        return null;
    });

    return {
        selectedCarriers,
        selectedCarriersBefore,
        unselectedCarriers,
    };
}

function carrierFilterSelected({
    action,
    carrierCode,
    carriers,
    totalTrips,
    type,
}) {
    const {
        selectedCarriers,
        selectedCarriersBefore,
        unselectedCarriers,
    } = sortCarriers(type, carriers, carrierCode, action);

    const property = {
        num_trips: totalTrips,
        selected_carriers: selectedCarriers,
        unselected_carriers: unselectedCarriers,
    };

    SnowplowService.fireStructuredEvent({
        action,
        category: 'react_search',
        label: `select_carrier_${type}`,
        property,
    });

    const filterTypeAction = action === 'click_only'
        ? 'exclusive'
        : action;

    amplitude.track('search_filtered', {
        carrier_code: carrierCode,
        filter_list_selected_count: selectedCarriers.length,
        filter_list_total_count: selectedCarriers.length + unselectedCarriers.length,
        filter_type: `carrier_${filterTypeAction}`,
        mode_type: type,
        results_count_before: totalTrips,
        updated_from: selectedCarriersBefore,
        updated_to: selectedCarriers,
    });
}

export default {
    carrierFilterSelected,
};
